import { Component, Input } from '@angular/core';

export interface INotes {
    subject: string;
    description: string;
    icon: string;
    editDate: string;
    userName: string;
}

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
    @Input()
    title: string;
    @Input()
    datasource: any;

    constructor() { }

    public hasData() {
        return this.datasource &&
            this.datasource.rows &&
            this.datasource.rows.length &&
            this.datasource.rows.length > 0;
    }
}
